import { useParams } from 'react-router-dom'
import TeamMemberForm from './TeamMemberForm'

const View = () => {
    const params = useParams()

    return (
        <TeamMemberForm
            inPopup={false}
            id={parseInt(params.teamMemberId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Team member updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update team member',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating team member...',
                },
            }}
        />
    )
}

export default View
